import { render } from "./configurationCenter.vue?vue&type=template&id=7a66d868&scoped=true"
import script from "./configurationCenter.vue?vue&type=script&lang=js"
export * from "./configurationCenter.vue?vue&type=script&lang=js"

import "./configurationCenter.vue?vue&type=style&index=0&id=7a66d868&scoped=true&lang=css"

import exportComponent from "E:\\web project\\web-serial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a66d868"]])

export default __exports__